import React from "react";
import { Fab } from "@mui/material";
import SupportAgentIcon from '@mui/icons-material/SupportAgent';

const FloatingButton = ({ label , onClick,...rest }) => {
  return (
    <Fab
      onClick={onClick}
      sx={{
        position: "fixed",
        bottom: 20,
        right: 30,
        backgroundColor: "#FFFFFF",
        color: "#000000",
        zIndex: 2500,
        width: 40,
        height: 40,
        minWidth: 40,
        padding: 0,
        boxShadow: "0 6px 12px rgba(0,0,0,0.2)",
        "&:hover": {
          backgroundColor: "#48b1b1",
        },
      }}
      {...rest}
    >
      <SupportAgentIcon sx={{ fontSize: 34 }} />
    </Fab>
  );
};

export default FloatingButton;
